export default __webpack_public_path__ + "static/media/marker.c6aa317d.svg";